/**
 * Theme-aware style helpers
 * Provides consistent light/dark mode styling for inline-styled pages
 */
export function getThemeStyles(isDark: boolean) {
  return {
    // Backgrounds
    pageBg: isDark
      ? 'linear-gradient(135deg, #0a0e1a 0%, #111827 50%, #0f172a 100%)'
      : 'linear-gradient(135deg, #f8fafc 0%, #ffffff 50%, #f1f5f9 100%)',
    pageBg2: isDark
      ? 'linear-gradient(to bottom, #030712, #0a0f1a, #030712)'
      : 'linear-gradient(to bottom, #f8fafc, #ffffff, #f8fafc)',
    pageBg3: isDark
      ? 'linear-gradient(160deg, #08090d 0%, #0f1117 30%, #131620 60%, #0d1117 100%)'
      : 'linear-gradient(160deg, #f8fafc 0%, #ffffff 30%, #f1f5f9 60%, #f8fafc 100%)',
    headerBg: isDark ? 'rgba(3,7,18,0.9)' : 'rgba(255,255,255,0.92)',
    cardBg: isDark ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.02)',
    cardBgStrong: isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.04)',
    modalBg: isDark ? '#1e293b' : '#ffffff',
    inputBg: isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.04)',
    
    // Text
    textPrimary: isDark ? '#e5e7eb' : '#0f172a',
    textWhite: isDark ? '#fff' : '#0f172a',
    textSecondary: isDark ? '#9ca3af' : '#64748b',
    textMuted: isDark ? '#6b7280' : '#94a3b8',
    textDim: isDark ? '#4b5563' : '#94a3b8',
    textLight: isDark ? '#e2e8f0' : '#1e293b',
    
    // Accent text (stays readable in both modes)
    accentIndigo: isDark ? '#818cf8' : '#4f46e5',
    accentPurple: isDark ? '#c084fc' : '#7c3aed',
    
    // Borders
    borderLight: isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.06)',
    borderMedium: isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
    borderStrong: isDark ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.12)',
    
    // Buttons
    ghostBg: isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.04)',
    ghostBorder: isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
    ghostHoverBg: isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.08)',
    
    // Hero gradient text
    heroGradient: isDark
      ? 'linear-gradient(135deg, #e2e8f0, #94a3b8)'
      : 'linear-gradient(135deg, #0f172a, #475569)',
    heroGradient2: isDark
      ? 'linear-gradient(90deg, #818cf8, #c084fc)'
      : 'linear-gradient(90deg, #4f46e5, #7c3aed)',
    
    // Shadows
    shadowColor: isDark ? 'rgba(0,0,0,0.3)' : 'rgba(0,0,0,0.08)',
  };
}
